/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Added by Jordan G. @shopify on April 21, 2020

$(window).on('load', function() {
  var $announcementBarClose = $('.announcement-bar__close');
  var $announcementBarHeight = $('.announcement-bar--visible').height() || 0;
  var $searchBar = $('#search_bar');
  var $searchIcon = $('#search_button');
  var $headerBarHeight = $('.site-header-sections').outerHeight();
  var $restOfSite = $('.main-content, .drawer-cover, .navigation');

  function _openSearchBar() {
    $searchBar.css('top', '0').find('.input-group__field').focus();
    $searchBar.css('z-index', '999');
  }

  function _closeSearchBar() {
    $searchBar.css('top', -$headerBarHeight - 50);
    $restOfSite.off();
  }

  $searchBar.removeAttr('style').css({
    'top': -$headerBarHeight - 20,
    'height': $headerBarHeight,
    'margin-top': $announcementBarHeight
  });

  $searchIcon.on('click', function() {
    _openSearchBar();

    $restOfSite.on('click', function() {
      event.preventDefault();
      _closeSearchBar();
    })
  })

  $announcementBarClose.on('click', function() {
    $searchBar.css('margin-top', '');
  })
})

// End of addition by Jordan G. @shopify on April 21, 2020